import * as React from 'react';

import { Errors } from '../../../i18n/messages';
import { IControlError, IControlSchema } from '../../Controls';
import {
  clearNonNumberCharacters,
  Component,
  I18NString,
  isNullOrEmpty,
} from '../../Utils';
import { IDispatcher } from '../extensions/Dispatcher';
import Alert from './Alert';
import Note from './Note';
import { isNull, isUndefined, isEmpty, replace } from 'lodash';
import Field from '../Field';
import { TextBoxValidate } from './validate';

export interface ITextBoxSchema extends IControlSchema {
  description: I18NString;
  maxLength: number;
  minLength?: number;
  disabled?: boolean;
  placeholder?: string;
  defaultValue?: string;
  isInteger?: boolean;
  lines?: number;
  value?: string;
  min?: number;
  max?: number;
  label?: string;
  extra: any;
}

export interface ITextBoxProps {
  schema: ITextBoxSchema;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
}

interface IState {
  lock: boolean;
  value: string;
  openInfo: boolean;
}

const Help = ({ onClick }) => (
  <span
    onClick={onClick}
    className="input-group-addon btn btn-default btn-circle"
  >
    <span className="glyphicon glyphicon-question-sign"></span>
  </span>
);

class TextBox extends Component<ITextBoxProps, IState> {
  private input: HTMLInputElement | HTMLTextAreaElement;

  constructor(props) {
    super(props);
    this.state = {
      lock: false,
      value: '',
      openInfo: false,
    };

    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onClick = this.onClick.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  public componentDidMount() {
    const {
      schema: { value },
      error: existingError,
    } = this.props;
    if (!isEmpty(value)) {
      this.props.dispatcher.onVisit(this.props.schema.id);
    }
    this.setState({ value });
    this.throttledChange(value);

    if (existingError) {
      return;
    }
    if (
      typeof this.props.schema.extra !== 'undefined' &&
      this.props.schema.extra.showHelp
    ) {
      this.setState({ openInfo: true });
    }

    const error = TextBoxValidate(value, this.props.schema);
    this.props.dispatcher.setError(
      this.props.schema.id,
      this.input.value,
      error && error.isError ? { message: error.message } : undefined,
      false,
    );
  }

  componentWillUpdate?(
    nextProps: Readonly<ITextBoxProps>,
    nextState: Readonly<IState>,
    nextContext: any,
  ): void {
    if (
      this.props.schema.value !== nextProps.schema.value &&
      nextState.value !== nextProps.schema.value
    ) {
      this.setState({ value: nextProps.schema.value });
    }
  }

  protected onChange(
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) {
    const value = e.target.value;

    this.setState({ value });
    this.throttledChange(value);
  }

  protected onBlur() {
    //"SumGrant"
    if (!this.input) {
      return;
    }
    let value = this.input.value;
    const error = TextBoxValidate(value, this.props.schema);
    this.props.dispatcher.onBlur(
      this.props.schema.id,
      value,
      !error,
      error && error.isError && { message: error.message },
    );
    this.props.dispatcher.onVisit(this.props.schema.id);
  }

  onClick() {
    this.setState({ openInfo: !this.state.openInfo });
  }

  public render() {
    const {
      schema: { extra },
      error,
      visited,
    } = this.props;
    const value = this.state.value || '';
    const errorText = visited && error && error.message;
    let className = 'default',
      input = null;
    // Error
    if (value && !errorText) {
      className = 'success';
    } else if (errorText) {
      className = 'error';
    }

    if (this.props.schema.type.toUpperCase() == 'TEXTAREA') {
      let textarea = (
        <>
          <textarea
            style={{ resize: 'vertical' }}
            className="form-control"
            onChange={this.onChange}
            onBlur={this.onBlur}
            value={value}
            ref={(input) => (this.input = input)}
            rows={this.props.schema.lines}
            disabled={this.props.schema.disabled}
          />
          {(typeof this.props.schema.minLength !== 'undefined' ||
            typeof this.props.schema.maxLength !== 'undefined') && (
            <div className="textarea-info">
              Всего: {value.toString().length}{' '}
              {typeof this.props.schema.minLength !== 'undefined' &&
              this.props.schema.minLength - value.toString().length > 0 ? (
                <span>
                  (Нужно еще{' '}
                  {this.props.schema.minLength - value.toString().length})
                </span>
              ) : (
                ''
              )}
            </div>
          )}
        </>
      );

      input = !isUndefined(this.props.schema.description) ? (
        <div className="input-group" style={{ width: '100%' }}>
          {textarea}
          {/*<Help onClick={this.onClick}></Help>*/}
        </div>
      ) : (
        textarea
      );
    } else if (this.props.schema.type.toUpperCase() == 'NUMBER') {
      input = (
        <div className="input-group" style={{ width: '100%' }}>
          <input
            type="text"
            className="form-control"
            inputMode="decimal"
            onChange={this.onNumberChange}
            onInput={this.onNumberInput}
            onBlur={this.onBlur}
            value={value}
            ref={(input) => (this.input = input)}
            disabled={this.props.schema.disabled}
          />
          <span className="input-group-addon">{this.props.schema.label}</span>
          {/*{*/}
          {/*    (!isUndefined(this.props.schema.description)) && (<Help onClick={this.onClick}></Help>)*/}
          {/*}*/}
        </div>
      );
    } else {
      let textbox = (
        <input
          type="text"
          className="form-control"
          placeholder={this.props.schema.placeholder}
          onChange={this.onChange}
          maxLength={this.props.schema.maxLength + 1}
          onBlur={this.onBlur}
          value={value}
          title={value}
          disabled={this.props.schema.disabled}
          ref={(input) => (this.input = input)}
        />
      );
      input = !isUndefined(this.props.schema.description) ? (
        <div className="input-group" style={{ width: '100%' }}>
          {textbox}
          {/*<Help onClick={this.onClick}></Help>*/}
        </div>
      ) : (
        textbox
      );
    }

    return (
      <Field
        {...this.props.schema}
        status={className}
        helpBtn={
          !isUndefined(this.props.schema.description) ? (
            <Help onClick={this.onClick} />
          ) : null
        }
      >
        {input}
        {errorText && <Alert>{errorText}</Alert>}
        {!isUndefined(this.props.schema.description) && this.state.openInfo && (
          <div
            className="alert alert-warning info-label"
            role="alert"
            dangerouslySetInnerHTML={{
              __html: this.tr(this.props.schema.description),
            }}
          ></div>
        )}
        {extra && extra.note && (
          <Note content={extra.note} dispatcher={this.props.dispatcher} />
        )}
      </Field>
    );
  }

  private onNumberInput = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const value = clearNonNumberCharacters(evt.target.value);
    this.setState({ ...this.state, value });
  };

  private onNumberChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    const value = clearNonNumberCharacters(e.target.value);
    this.setState({ ...this.state, value });
    this.throttledChange(value);
  };

  private throttledChange(value: string) {
    setTimeout(() => {
      if (value !== this.state.value) {
        return;
      }
      const error = TextBoxValidate(value, this.props.schema);
      this.props.dispatcher.onBlur(
        this.props.schema.id,
        this.state.value,
        error && error.isError,
        error && error.isError && { message: error.message },
      );
    }, 300);
  }
}

export function createTextBox(
  schema: IControlSchema,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
): React.ReactElement<any> {
  return (
    <TextBox
      schema={schema as ITextBoxSchema}
      dispatcher={dispatcher}
      error={error}
      visited={visited}
    />
  );
}
